import React from 'react';
import PropTypes from 'prop-types';

import {FiltersWrapper} from '@appComponents/HOCFiltersWrapper';
import {CountriesFilter} from '@utils/commonFilters/CountriesFilter';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';

const CompetitorsFilters = (props) => {
    return (
        <div className='competitors__filters filter__controls__container'>
            <SearchFilter
                loading={props.loading}
                filters={props.filters.AvCompetitors}
                restoreFilterValues={props.restoreFilterValues}
            />
            <CountriesFilter
                countries={props.data.countries}
                loading={props.loading}
                filters={props.filters.AvCompetitors}
                restoreFilterValues={props.restoreFilterValues}
            />
        </div>
    );
};

CompetitorsFilters.propTypes = {
    filters: PropTypes.shape({
        AvCompetitors: PropTypes.object,
    }),
    data: PropTypes.shape({
        countries: PropTypes.array,
    }),
    loading: PropTypes.bool,
    restoreFilterValues: PropTypes.func.isRequired,
};

CompetitorsFilters.defaultProps = {
    filters: {
        AvCompetitors: {},
    },
    data: {
        countries: [],
    },
    loading: false,
};

export default FiltersWrapper(CompetitorsFilters, {name: 'AvCompetitors'});
